import { render, staticRenderFns } from "./TagTree.vue?vue&type=template&id=0fb957d9&scoped=true"
import script from "./TagTree.vue?vue&type=script&lang=js"
export * from "./TagTree.vue?vue&type=script&lang=js"
import style0 from "./TagTree.vue?vue&type=style&index=0&id=0fb957d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb957d9",
  null
  
)

export default component.exports